import { CallListModal } from "../call-list/call-list-modal";
import { useCallListGlobalModalContext } from "./use-call-list-global-modal-context";

export function GlobalCallListModal() {
  const ctx = useCallListGlobalModalContext();

  return (
    <CallListModal
      open={!!ctx.consultantId}
      consultantId={ctx.consultantId || ""}
      onClose={() => ctx.open(null)}
    />
  );
}
